// extracted by mini-css-extract-plugin
module.exports = {"page__wrapper":"page__wrapper--7de4a5"};